// Import business logic.
import Position from './model/logic/Position.js';

/**
 * Overlay model business logic.
 *
 * @memberof module:Overlay.Model
 * @namespace
 */
const Logic = {
	Position:Position
};
export { Logic };

/**
 * Overlay model.
 *
 * @author Tim Loram
 *
 * @memberof module:Overlay
 * @namespace
 *
 * @type {Object}
 * @property {Object} Logic All model Business Logic
 */
const Model = {
	Logic:Logic
};

export default Model;